import { combineReducers } from 'redux';
import feathers from '@feathersjs/client';
import { fork, all } from 'redux-saga/effects';
import { reducer as formReducer } from 'redux-form';
import { connectRouter } from 'connected-react-router'
import { createBrowserHistory } from 'history'

import user from './user/reducers';
import hcps from './hcps/reducers';
import patients from './patient/reducers';
import treatmentSites from './treatmentSite/reducers';

import * as userSagas from './user/sagas';
import * as hcpsSagas from './hcps/sagas';
import * as patientsSagas from './patient/sagas';
import * as treatmentSitesSagas from './treatmentSite/sagas';
import 'whatwg-fetch';

//import { pageReducer } from './page/reducers';

export const history = createBrowserHistory();

export const rootReducer = combineReducers({
  user,
  hcps,
  patients,
  treatmentSites,
  form: formReducer,
  router: connectRouter(history),
});

export function* rootSaga() {
  yield all([
    ...Object.values(hcpsSagas),
    ...Object.values(userSagas),
    ...Object.values(patientsSagas),
    ...Object.values(treatmentSitesSagas),
  ].map(fork));
}

let host = "";

if (process.env.NODE_ENV === 'development') {
  host = 'http://localhost:3030';
  //host = 'http://192.168.0.39:3030';
} else {
  if (window.location.hostname.indexOf('stag') !== -1) {
    host = 'https://api-stag.medax.net.au';
  } else if (window.location.hostname.indexOf('training') !== -1) {
    host = 'https://api-training.medax.net.au';
  } else {
    host = 'https://api.medax.net.au';
  }
}

export const app = feathers()
  .configure(feathers.rest(host).fetch(window.fetch))
  .configure(feathers.authentication({
    storage: window.localStorage
  }));

export const userService = app.service('users');
export const patientService = app.service('patients');
export const treatmentSiteService = app.service('treatment-sites');
export const hostUrl = host;
export const verificationService = app.service('verification');
export const ordersService = app.service('daily-tasks');
export const csvService = app.service('csv');